export enum StateIndicator {
    Idle = "Idle",
    Loading = "Loading",
    Failed = "Failed",
    Success = "Success"
}